import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOffersCountActionType {
  OffersCountUpdated = 'OffersCount/updated',
}

export type TOffersCountAction = ITypedReduxAction<EOffersCountActionType.OffersCountUpdated, number>;

export type TOffersCountActions = TOffersCountAction;
